import CloseIcon from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/Delete";
import {
  ListItemText,
  ListItemIcon,
  MenuItem,
  MenuList,
  IconButton,
  Button,
} from "@mui/material";

import { Option } from "api/common/types/common.types";
import { useFieldContext } from "components/Forms/AppForm";

const TdDisplayList = () => {
  const field = useFieldContext<Option[]>();

  const tds = field.state.value;

  return (
    <MenuList sx={{ paddingTop: 0 }}>
      {tds.map((td) => (
        <TdItem td={td} key={td.value} />
      ))}
      {tds.length > 0 && (
        <Button
          startIcon={<DeleteIcon />}
          variant="outlined"
          color="error"
          fullWidth
          sx={{
            marginTop: "1em",
          }}
          size="small"
          onClick={() => {
            field.handleChange([]);
          }}
        >
          Clear All
        </Button>
      )}
    </MenuList>
  );
};
export default TdDisplayList;

const TdItem = ({ td }: { td: Option }) => {
  const field = useFieldContext<Option[]>();
  return (
    <MenuItem divider disableRipple>
      <ListItemText>{td.label}</ListItemText>
      <ListItemIcon>
        <IconButton
          size="small"
          onClick={() =>
            field.handleChange(
              field.state.value.filter((val) => val.value !== td.value),
            )
          }
        >
          <CloseIcon />
        </IconButton>
      </ListItemIcon>
    </MenuItem>
  );
};
